import { render, staticRenderFns } from "./SiteActions.vue?vue&type=template&id=6c18fa70"
import script from "./SiteActions.vue?vue&type=script&lang=js"
export * from "./SiteActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports